export default __webpack_public_path__ + "static/media/CountCouple_05.7046bfa2.png";